module.exports = __webpack_public_path__ + "img/code2.11a990bc.png";